import { PORTALTHIRD_BASE_URL } from "./constants/constants";
const isLocal = Boolean(window.location.hostname === "localhost");

export function register(config) {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      registerValidSW(config);
    });
  }
}

function registerValidSW(config) {
  const serviceWorkUrl = isLocal ? "/sw.js" : `/${PORTALTHIRD_BASE_URL}/sw.js`;
  navigator.serviceWorker
    .register(serviceWorkUrl, { scope: isLocal ? "/" : `/${PORTALTHIRD_BASE_URL}/` })
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                "New content is available and will be used when all " +
                  "tabs for this page are closed. See https://bit.ly/CRA-PWA."
              );
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log("Content is cached for offline use.");

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
